import {createMultiPathSVG} from './TEMPLATE'

// phosphor: pause-fill (fill weight)
export const Pause_Filled_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M216,48V208a16,16,0,0,1-16,16H160a16,16,0,0,1-16-16V48a16,16,0,0,1,16-16h40A16,16,0,0,1,216,48ZM96,32H56A16,16,0,0,0,40,48V208a16,16,0,0,0,16,16H96a16,16,0,0,0,16-16V48A16,16,0,0,0,96,32Z',
  ],
  viewBox: '0 0 256 256',
})
